import { infiniteQueryOptions } from "@tanstack/react-query";
import { apiGet } from "../client";
import type { Order, Page } from "../types";
import { qk } from "./qk";
import type { OrderListParams } from "./qk";

export const ordersInfiniteQuery = (params: OrderListParams = {}) =>
  infiniteQueryOptions({
    queryKey: qk.orders.list(params),
    queryFn: ({ pageParam }: { pageParam: string | null }) => {
      const search = new URLSearchParams();
      if (params.status) search.set("status", params.status);
      if (params.q) search.set("q", params.q);
      search.set("limit", "50");
      if (pageParam) search.set("cursor", pageParam);
      return apiGet<Page<Order>>(`/api/orders?${search.toString()}`);
    },
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage: Page<Order>) => lastPage.nextCursor,
    staleTime: 30_000, // plan §5: dashboard
  });
